module.exports = __webpack_public_path__ + "static/media/gl.28bf64e4.svg";